import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import Quilleditor from "../../Quilleditor/Quilleditor";
import DatePicker from "../../DatePicker/datePicker";
import EditorInput from "../../Inputs/EditorInput";
import ResumeButton from "../../Buttons/ResumeButton/ResumeButton";
import DateEdit from "../../DatePickerNew/DatePicker";

function WorkExperienceItem(props) {
  const [t, i18n] = useTranslation("common");

  const [showDatePicker, setShowDatePicker] = useState(false);

  const handleDatePicker = (selected) => {
    setShowDatePicker(!showDatePicker);
  };

  const month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var dt = new Date();
  var y = dt.getFullYear();
  var m = month[dt.getMonth()];

  return (
    <>
      <div className="col-md-12 mb-3">
        <div className=" mb-3">
          <h6 className="m-0 d-inline-block">Add Custom Section</h6>
          {!props.showPopup && (
            <img
              src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/trash.svg`}
              alt="trash"
              className="ml-1 delete_icon"
              onClick={props.handleDelete}
            />
          )}
          <div className="row">
            <div className="col-md-6">
              <EditorInput
                label={"Title"}
                value={props.res.title}
                name="title"
                autoComplete="off"
                className={`form-control  ${props.sectionId}focus${props.index}`}
                onChange={props.resumeHandler}
                onBlur={props.resumeUpdate}
              />
            </div>
            <div className="col-md-6 mb-3">
              <div className="">
                <span className="basiceditor-date-label">Date</span>
                <p className="basic-experience-date-section">
                  <span
                    className="experience-from"
                    data-placeholder="From"
                    // style={{
                    //   fontFamily: styles.bodyFont,
                    //   fontSize: styles.bodyFontSize,
                    // }}
                    onClick={() => handleDatePicker("from")}
                  >
                    {props &&
                    props.res &&
                    props.res.dateRange &&
                    props.res.dateRange.fromYear &&
                    props.res.dateRange.fromMonth
                      ? `${props.res.dateRange.fromMonth} / ${props.res.dateRange.fromYear}`
                      : props &&
                        props.res &&
                        props.res.dateRange &&
                        props.res.dateRange.fromYear &&
                        props.res.dateRange.fromYear
                      ? props.res.dateRange.fromYear
                      : `${m} / ${y}`}
                  </span>{" "}
                  -{" "}
                  <span
                    data-placeholder="To"
                    // style={{
                    //   fontFamily: styles.bodyFont,
                    //   fontSize: styles.bodyFontSize,
                    // }}
                    onClick={() => handleDatePicker("to")}
                  >
                    {props &&
                    props.res &&
                    props.res.dateRange &&
                    props.res.dateRange.isOnGoing
                      ? props &&
                        props.res &&
                        props.res.dateRange &&
                        props.res.dateRange.onGoingText != ""
                        ? props &&
                          props.res &&
                          props.res.dateRange &&
                          props.res.dateRange.onGoingText
                        : "Ongoing"
                      : props &&
                        props.res &&
                        props.res.dateRange &&
                        props.res.dateRange.toYear &&
                        props &&
                        props.res &&
                        props.res.dateRange &&
                        props.res.dateRange.toMonth
                      ? `${
                          props &&
                          props.res &&
                          props.res.dateRange &&
                          props.res.dateRange.toMonth
                        } / ${
                          props &&
                          props.res &&
                          props.res.dateRange &&
                          props.res.dateRange.toYear
                        }`
                      : props &&
                        props.res &&
                        props.res.dateRange &&
                        props.res.dateRange.toYear
                      ? props &&
                        props.res &&
                        props.res.dateRange &&
                        props.res.dateRange.toYear
                      : "Ongoing"}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* <EditorInput
					label={t(`customDate.position`)}
					value={props.res.field1}
					name="field1"
					autoComplete="off"
					className={`form-control  ${props.sectionId}focus${props.index}`}
					onChange={(e) => props.resumeHandler(e)}
					onBlur={(e) => props.resumeUpdate(e, 'date')}
				/> */}
      </div>
      {/* <div className="col-md-12 mb-3">
				<EditorInput
					label={t(`customDate.company`)}
					value={props.res.field2}
					name="field2"
					autoComplete="off"
					className="form-control "
					onChange={(e) => props.resumeHandler(e)}
					onBlur={(e) => props.resumeUpdate(e, 'date')}
				/>
			</div> */}

      {/* <div className="col-md-12 mb-3">
				<div className="row">
					<div className="col-md-6">
						<EditorInput
							label={t(`experience.website`)}
							value={props.res.website}
							name="website"
							autoComplete="off"
							className="form-control "
							onChange={(e) => props.resumeHandler(e)}
							onBlur={(e) => props.resumeUpdate(e, 'date')}
						/>
					</div>
					<div className="col-md-6">
						<EditorInput
							label={t(`experience.location`)}
							value={props.res.location}
							name="location"
							autoComplete="off"
							className="form-control "
							onChange={(e) => props.resumeHandler(e)}
							onBlur={(e) => props.resumeUpdate(e, 'date')}
						/>
					</div>
				</div>
			</div> */}
      <div className="col-md-12">
        <label>{t(`customDate.description`)}</label>
        <Quilleditor
          type="basic"
          theme={"snow"}
          inivalue={props?.res?.description?.replace(/\n|\r/g, "")}
          className={`${props.sectionId}focus${props.index}`}
          current={props.index}
          id={props.sectionId}
          sectionId={props.sectionId}
          placeholder="Whats the one thing that you want someone to remember to after reading your resume?"
          setvalue={props.handleEditorChange}
          onBlur={props.resumeUpdate}
        />

        {showDatePicker && showDatePicker && (
          <>
            <DateEdit
              dateHandler={props.dateHandler}
              index={props.index}
              response={props.res}
              showDatePicker={showDatePicker}
              setShowDatePicker={setShowDatePicker}
              isSelectedFrom={props.isSelectedFrom}
              sectionId={props.sectionId}
            />
          </>
        )}

        <div className={props.showPopup ? "mb-1 mt-3 d-flex" : " d-flex"}>
          {props.saveIndex == props.index ? (
            <ResumeButton success alt="plus" title="Save" />
          ) : (
            // <button
            // 	type="button"
            // 	className="btn submitbtn disable_btn"
            // >
            // 	<i
            // 		className="fa fa-circle-o-notch fa-spin"
            // 		style={{ marginRight: "5px" }}
            // 	/>

            // 	Save
            // </button>
            <ResumeButton
              success
              alt="plus"
              title="Save"
              className="mr-2"
              onClick={() => {
                props.resumeUpdate();
                props.setSaveIndex();
              }}
            />
            // <button
            // 	type="button"
            // 	className="btn submitbtn"
            // 	onClick={() => {
            // 		props.resumeUpdate()
            // 		props.setSaveIndex()
            // 	}}
            // >Save</button>
          )}
          <ResumeButton
            white
            alt="plus"
            title="Cancel"
            onClick={props.resumeUpdateCancel}
          />
        </div>
      </div>
    </>
  );
}

export default WorkExperienceItem;
